import { TicketingData } from "@avenueops/shared-types";
import UncontrolledInputSearchableSelect from "components/inputs/UncontrolledInputSearchableSelect";
import UncontrolledInputTextarea from "components/inputs/UncontrolledInputTextarea";

interface Props {
  integrationId: string;
  integrationData?: any;
  fieldValue: string;
  fieldError: any;
  onChange: any;
  isFirst: boolean;
}

export default function EnhancedMergeUserMappingInput({ integrationId, integrationData, fieldValue, fieldError, onChange, isFirst }: Props) {
  const title = isFirst ? `Data in Avenue` : undefined;
  let options = integrationData
    ? integrationData.users
        ?.filter((user: TicketingData) => user.integrationId === integrationId)
        .map((user: TicketingData) => ({ value: user.id, label: user.name })) ?? []
    : [];

  // Fallback to a text area input if there are no options
  return options.length > 0 ? (
    <div>
      <UncontrolledInputSearchableSelect
        title={title}
        disabled={false}
        options={options}
        val={fieldValue}
        onChange={onChange}
        placeholder={"Users ..."}
        error={fieldError}
      />
    </div>
  ) : (
    <div>
      <UncontrolledInputTextarea
        title={title}
        placeholder="Embed data like this: {{id}}"
        value={fieldValue}
        onChange={onChange}
        error={fieldError}
        className="w-[20rem] min-w-[10rem]"
      />
    </div>
  );
}
